import React from 'react';
import { Link } from 'react-router-dom';
import propTypes from 'prop-types';

import BadgeThin from '../../../components/Badges/BadgeThin';
import StarRating from '../../../components/StarRating';
import date from '../../../helpers/date';
import {
  customerReviewStatusColors,
  getCustomerReviewStatus,
  getCustomerReviewSource
} from '../../../constants/kickavenue';
import { SubText, CellStack, ReviewMeta } from '../styled';

const EMPTY_VALUE = '-';
const NO_REVIEW_TEXT = 'No written review';

// DateToHuman pulls in moment/locale/id, which flips moment's global locale wherever
// it loads. Pinning en keeps the month abbreviations the design specifies.
const formatCreatedAt = value => date(value).locale('en').format('D MMM YYYY');

const RowItem = props => {
  const { item, detailRoute } = props;
  const productVariant = item.product_variant || {};
  const sale = item.sale || {};
  const statusLabel = getCustomerReviewStatus(item.status);
  const sourceLabel = getCustomerReviewSource(item.source);

  return (
    <tr>
      <th className="v-center" scope="row">{ item.id }</th>
      <td className="v-center">
        <CellStack>
          <span>{ item.review_text || NO_REVIEW_TEXT }</span>
          <ReviewMeta>
            <StarRating value={item.rating} />
            <SubText>by { item.display_name || EMPTY_VALUE }</SubText>
          </ReviewMeta>
        </CellStack>
      </td>
      <td className="v-center">
        <CellStack>
          <span>{ productVariant.display_name || EMPTY_VALUE }</span>
          <SubText>{ productVariant.SKU || EMPTY_VALUE }</SubText>
        </CellStack>
      </td>
      <td className="v-center">
        <CellStack>
          <span>{ sale.invoice_number || EMPTY_VALUE }</span>
          <SubText>{ item.created_at? formatCreatedAt(item.created_at): EMPTY_VALUE }</SubText>
        </CellStack>
      </td>
      <td className="v-center">
        <CellStack>
          <span>
            <BadgeThin color={customerReviewStatusColors[item.status] || 'secondary'}>
              { statusLabel || item.status || EMPTY_VALUE }
            </BadgeThin>
          </span>
          <SubText>Source: { sourceLabel || item.source || EMPTY_VALUE }</SubText>
        </CellStack>
      </td>
      <td className="v-center">
        <Link
          to={`${detailRoute}/${item.id}`}
          className="btn btn-link"
          aria-label={`Details of review ${item.id}`}
        >
          Details
        </Link>
      </td>
    </tr>
  )
}

export default RowItem;

RowItem.propTypes = {
  item: propTypes.shape({
    id: propTypes.number,
    rating: propTypes.number,
    review_text: propTypes.string,
    display_name: propTypes.string,
    status: propTypes.string,
    source: propTypes.string,
    created_at: propTypes.string,
    product_variant: propTypes.object,
    sale: propTypes.object
  }).isRequired,
  detailRoute: propTypes.string.isRequired
}
